export default __webpack_public_path__ + "static/media/scale01.31b271d8.svg";